
<template>
  <div>
    <IKFiltroFuncionario ref="ikFiltroFuncionario"/>    
    <h6 class="p-text-bold">Período</h6>    
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">            
            <Calendar v-model="dataInicio" view="month" dateFormat="mm/yy" :yearNavigator="true" :yearRange="rangeData" 
            :showIcon="true" :manualInput="false" :locale="localeCalendarBR"/>				
        </div>        
    </div>
    <div class="p-d-flex p-jc-left">		
        <Button label="Gerar PDF" icon="pi pi-file-pdf" class="p-mt-3 p-mr-2" @click="processar" 
        :disabled="bloquearEnivo"/>
        <IKMonitoramentoDocumentos  ref="ikMonitoramentoDocumentos" :callback="finalizar"/>       
    </div>    
  </div>
</template>

<script>
import RelatorioService from '@/service/RelatorioService';
import IKFiltroFuncionario from '@/components/template/IKFiltroFuncionario';
import IKMonitoramentoDocumentos from '@/components/template/IKMonitoramentoDocumentos';
import { exibirMensagem, exibirMensagemSis, preViewArquivo, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    relatorioService: null,
    data() {
        return {       
            pararTimeout: false,     
            bloquearEnivo: false,         
            dataInicio: new Date(),
            rangeData: '',
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        /**
         * 
         */
        exportarPdf() {
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let requisicao = {               
                mesSelecionado: this.dataInicio.getMonth()+1,
                anoSelecionado: this.dataInicio.getFullYear(),
                idsFuncionarios: idsFuncionarios,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.relatorioService.exportarEspelhoPonto(requisicao)
            .then(resp => {     
                preViewArquivo(resp.data);             
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });
        },
        /**
         * 
         */
        processar() {
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let requisicao = {               
                mesSelecionado: this.dataInicio.getMonth()+1,
                anoSelecionado: this.dataInicio.getFullYear(),
                idsFuncionarios: idsFuncionarios,   
                idsCentrosCustos: dados.idsCentrosCustos,    
                ativo: dados.ativo,       
                todos: dados.todos,
                nomeDocumento: 'Espelho de Ponto',
                nomeArquivo: 'Espelho_Ponto',
                servico: 'espelhoPonto',
                tipoDocumento: 'pdf',
                cnpj: dados.cnpj,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.relatorioService.processar(requisicao)
            .then(resp => {     
                this.bloquearEnivo = true;
                this.$refs.ikMonitoramentoDocumentos.iniciarMonitoramento(resp.data); 
            })
            .catch(erro => {
                exibirMensagem(this, erro)
            });
        },
        /**
         * 
         */
        finalizar() {            
            this.bloquearEnivo = false;
        },       
        /**
         * 
         */
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
        },
    },
    created() {
        this.relatorioService = new RelatorioService();
    },
    mounted() {
        this.criarRangeData();
    },
    beforeDestroy() {
        this.pararTimeout = true;
    },
    components: {
        'IKFiltroFuncionario': IKFiltroFuncionario,
        'IKMonitoramentoDocumentos': IKMonitoramentoDocumentos
    }
}
</script>

<style>

</style>